import { Component, ViewChild, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ReleaseMgmtService } from '@app/shared/services/releaseMgmtService';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { AgGridModule } from 'ag-grid-angular';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { AgHeaderRendererComponent } from '@app/modules/add-view-release-list/ag-header-renderer/ag-header-renderer.component';
import { PageHeaderComponent } from '@app/shared/page-header/page-header.component';
import { LoaderService } from '@app/shared/services/loader.service';
@Component({
    standalone: true,
    selector: 'app-release-status',
    templateUrl: './release-status.component.html',
    styleUrls: ['./release-status.component.scss'],
    imports: [CommonModule, AgGridModule, MatIconModule, RouterModule, MatToolbarModule, PageHeaderComponent]
})
export class ReleaseStatusComponent implements OnChanges, OnInit {
    @ViewChild('agGrid') agGrid: AgGridAngular;
    releaseId = 0;
    paginationPageSize = 10;
    infiniteInitialRowCount = 30;
    styleChipDiv = 'width:100%; height: calc(100vh - 195px); flex: 1 1 auto; border: 1px solid #DFDFDF;';

    overlayNoRowsTemplate = `<span style="font-weight: 400; color: #757575; ">No records found</span>`;
    rowData: any[] = [];
    filteredRowData: any[] = [];
    serviceIds: number[] = []; // Fill this with all serviceIds for the release
    pageTitle = 'Branch Creation Status';
    pageSubTitle = 'View the status of branch creation for the release';
    columnDefs = [
        { headerName: 'Service Name', field: 'serviceName', filter: true, tooltipField: 'serviceName' },
        { headerName: 'Service Branch Name', field: 'branchName', filter: true, tooltipField: 'branchName' },
        {
            headerName: 'Service Branch Creation Status',
            field: 'status',
            filter: true,
            minWidth: 260,
            cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
            tooltipField: 'status',
            cellRenderer: params => {
                const btnStyle = `
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 120px;
                    height: 25px;
                    min-width: 110px;
                    padding: 0 12px;
                    border-radius: 16px;
                    font-weight: 500;
                    cursor: default;
                    white-space: nowrap;
                    border: none;
                    box-shadow: 0 1px 2px rgba(60,60,60,0.07);
                `;
                const status = params.value ? params.value.toLowerCase() : '';
                if (status === 'success') {
                    return `<span style="${btnStyle} background: #168736; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'inprogress') {
                    return `<span style="${btnStyle} background: #ED6500; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'failed') {
                    return `<span style="${btnStyle} background: #ed0000; color: #fff; border: none;">${params.value}</span>`;
                }
                if (status === 'notstarted') {
                    return `<span style="${btnStyle} background: #BDBDBD; color: #212121; border: none;">${params.value}</span>`;
                }
                return `<span style="${btnStyle} background: #f5f5f54a; color: #212121; border: none;">${params.value}</span>`;
            }
        },
        { headerName: 'Created By', field: 'createdBy', filter: true, tooltipField: 'createdBy' },
        {
            headerName: 'Created On',
            dataType: 'date',
            field: 'createdOn',
            filter: 'agDateColumnFilter',
            filterParams: {
                buttons: ['clear'],
                filterOptions: ['equals'],
                defaultOption: 'equals',
                suppressAndOrCondition: true,
                comparator: (filterLocalDateAtMidnight, cellValue) => {
                    if (!cellValue) return -1;
                    const cellDate = new Date(cellValue);
                    // Compare only the date part
                    if (
                        cellDate.getFullYear() === filterLocalDateAtMidnight.getFullYear() &&
                        cellDate.getMonth() === filterLocalDateAtMidnight.getMonth() &&
                        cellDate.getDate() === filterLocalDateAtMidnight.getDate()
                    ) {
                        return 0;
                    }
                    return -1;
                }
            },
            tooltipValueGetter: (params: ICellRendererParams) => params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '',
            cellRenderer: (params: ICellRendererParams) => {
                const formattedDate = params.value ? moment(params.value).format('MMM DD, YYYY, HH:mm A') : '';
                return formattedDate;
            }
        },
      { minWidth: 350, headerName: 'Status Log', field: 'comments', filter: true }
    ];

    defaultColDef = {
        minWidth: 0,
        with: 0,
        resizable: true,
        sortable: true,
        filter: true,
    };
    releaseName = '';

    constructor(public loader: LoaderService, private ReleaseMgmtService: ReleaseMgmtService, public route: ActivatedRoute,) { }
    ngOnInit(): void {
        const urlParamsMap = this.route.snapshot?.queryParamMap;
        this.releaseId = Number(urlParamsMap.get('releaseId'));
        this.filterByServiceId();
    }


    onGridReady(params: any) {
        if (!params) return;
        this.agGrid.api = params.api;
        // this.filterByServiceId();
    }

    refreshTable() {
        this.filterByServiceId();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['serviceId']) {
            this.filterByServiceId();
        }
    }

    filterByServiceId() {
        if (!this.releaseId) {
            this.rowData = [];
            this.filteredRowData = [];
            if (this.agGrid?.api) {
                this.agGrid.api.setGridOption('rowData', []);
            }
            return;
        }
        this.loader.showSpinner.next(true);
        this.ReleaseMgmtService.apiGetReleaseViewBranchCreationStatus(this.releaseId)
            .subscribe({

                next: (response) => {
                    if (response.length > 0) {
                        // Map each item to match grid columns
                        this.rowData = (response || []).map(item => ({
                            serviceName: item.serviceName,
                            branchName: item.branchName,
                            status: item.branchCreationStatus,
                            createdOn: item.createdDateTime ? new Date(item.createdDateTime) : null,
                            createdBy: item.createdBy,
                            comments: item.serviceLog || ''
                        }));
                        this.filteredRowData = this.rowData;
                        if (this.agGrid?.api) {
                            this.agGrid.api.setGridOption('rowData', this.filteredRowData);
                            this.releaseName = this.filteredRowData[0].releaseName;
                        }
                    }
                    this.loader.showSpinner.next(false);
                },
                error: (error) => {
                    this.loader.showSpinner.next(false);
                    this.overlayNoRowsTemplate = `<span style="font-weight: 400; color: #757575;">No records found</span>`;
                    if (this.agGrid?.api) {
                        this.agGrid.api.setGridOption('rowData', []);
                        this.agGrid.api.showNoRowsOverlay();
                    }
                    this.rowData = [];
                    this.filteredRowData = [];
                }
            });
    }
}
